import { render, staticRenderFns } from "./OrgOverview.vue?vue&type=template&id=0afa791d&scoped=true&"
import script from "./OrgOverview.vue?vue&type=script&lang=js&"
export * from "./OrgOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrgOverview.vue?vue&type=style&index=0&id=0afa791d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa791d",
  null
  
)

export default component.exports